import type { UserSessionData } from '@cencosud-cencommerce/paris-login';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

interface CustomerSessionData extends UserSessionData {
  tokenUserId?: string;
  anonymousId?: string; // For guest users
}

export const getUserSessionData = (): CustomerSessionData | null => {
  const sessionData = localStorage.getItem('sessionData');
  return sessionData ? JSON.parse(sessionData) : null;
};

export const getGuestSessionData = (): CustomerSessionData | null => {
  const sessionData = localStorage.getItem('guestSessionData');
  return sessionData ? JSON.parse(sessionData) : null;
};

const useGetCustomerData = () => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const customerContext = useCustomerContext();

  const isLogged = !!cart?.customerId;
  const anonymousId = cart?.anonymousId ?? '';
  const customerId = cart?.customerId ?? '';
  const customerRut = cart?.shippingAddress?.customerRut ?? '';
  let email = cart?.shippingAddress?.email ?? '';

  if (isLogged) {
    const customerContextEmail = customerContext?.customer?.data?.email;
    email = customerContextEmail ?? '';
  }

  if (email === '') {
    const sessionData = getUserSessionData();
    email = sessionData?.email ?? '';
  }

  return {
    anonymousId,
    email,
    customerId,
    customerRut
  };
};

export { useGetCustomerData };
